import { Injectable, signal } from '@angular/core';
import { IToastController, Toast, ToastKind } from '../../../domain/global/i-toast-controller';

const SHORT_DURATION_MS = 3000;
const LONG_DURATION_MS = 6000;

@Injectable({
  providedIn: 'root',
})
export class ToastController implements IToastController {
  readonly toasts = signal<Toast[]>([]);

  private nextId = 1;

  public showSuccessMessage(message: string): void {
    this.push('success', message);
  }

  public showErrorMessage(message: string): void {
    this.push('error', message);
  }

  public showInfoMessage(message: string): void {
    this.push('info', message);
  }

  public dismiss(id: number): void {
    this.toasts.update(current => current.filter(toast => toast.id !== id));
  }

  private push(kind: ToastKind, message: string): void {
    const id = this.nextId++;
    this.toasts.update(current => [...current, { id, kind, message }]);

    const duration = message.split(' ').length > 12 ? LONG_DURATION_MS : SHORT_DURATION_MS;
    setTimeout(() => this.dismiss(id), duration);
  }
}
